import {ElementRef, Inject, Injectable, LOCALE_ID} from '@angular/core';
import {DatePipe} from '@angular/common';

@Injectable()
export class DateHandlerService {

	constructor(@Inject(LOCALE_ID) private _locale: string) { }

	formatDate(d: Date): string {
		if (d && d.toString() !== 'Invalid Date') {
			const datePipe = new DatePipe(this._locale);
			return datePipe.transform(d.toString(), 'yyyy-MM-dd : HH:mm:ss');
		} else {
			return '';
		}
		
	}
	formatDateNoTime(d: Date): string {
		if (d && d.toString() !== 'Invalid Date') {
			const datePipe = new DatePipe(this._locale);
			return datePipe.transform(d.toString(), 'yyyy-MM-dd');
		} else {
			return '';
		}
	}
	
	formatDateClassic(d: Date): string {
		if (d && d.toString() !== 'Invalid Date') {
			const datePipe = new DatePipe(this._locale);
			return datePipe.transform(d.toString(), 'dd/MM/yyyy');
		} else {
			return '';
		}
	}
	
	formatTimeClassic(d: Date): string {
		if (d && d.toString() !== 'Invalid Date') {
			const datePipe = new DatePipe(this._locale);
			return datePipe.transform(d.toString(), 'HH:mm');
		} else {
			return '';
		}
	}
	
	
	getTimeDiff(starting, until) {
		let difference = until.getTime() - (starting.getTime());
		const days = Math.floor(difference / 1000 / 60 / 60 / 24);
		difference -= days * 1000 * 60 * 60 * 24;
		
		const hours = Math.floor(difference / 1000 / 60 / 60);
		let hoursStr = hours.toString();
		if (hoursStr.length === 1) {
			hoursStr = '0' + hoursStr;
		}
		difference -= hours * 1000 * 60 * 60;
		
		const minutes = Math.floor(difference / 1000 / 60);
		let minutesStr = minutes.toString();
		if (minutesStr.length === 1) {
			minutesStr = '0' + minutesStr;
		}
		difference -= minutes * 1000 * 60;
		
		const seconds = Math.floor(difference / 1000);
		let secondsStr = seconds.toString();
		if (secondsStr.length === 1) {
			secondsStr = '0' + secondsStr;
		}
		
		let to_return = '';
		
		if (days === 1) {
			to_return += '1 giorno, ';
			
		} else if (days > 1) {
			to_return += days + ' giorni, ';
		}
		to_return += hoursStr + ':' + minutesStr + ':' + secondsStr;
		/*
		if (hours === 1) {
			to_return += '1 ora, ';

		} else {
			to_return += hours + ' ore, ';
		}
		if (minutes === 1) {
			to_return += '1 minuto, ';

		} else {
			to_return += minutes + ' minuti, ';
		}
		if (seconds === 1) {
			to_return += '1 secondo';

		} else {
			to_return += seconds + ' secondi';
		}*/
		
		return to_return;
	}
}
